import { render } from "./AdminModulTaskPage.vue?vue&type=template&id=262d47e0"
import script from "./AdminModulTaskPage.vue?vue&type=script&lang=js"
export * from "./AdminModulTaskPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__